import { useTheme } from '@emotion/react';
import { Box, IconPlay, MediaModal, TextButton, useDisclosure, VideoTile } from 'designsystem';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface HeroVideoProps {
    videoUrl: string;
}
const HeroVideo: FC<HeroVideoProps> = ({ videoUrl }) => {
    const disclosureProps = useDisclosure();
    const { formatMessage } = useIntl();
    const { onOpen } = disclosureProps;
    const { tokens } = useTheme();

    return (
        <>
            <VideoTile url={videoUrl} gridRow="1" display={['none', null, null, 'flex']}>
                <TextButton
                    iconLeft={
                        <Box
                            sx={{ aspectRatio: 1 }}
                            w={10}
                            borderWidth={tokens.BorderWidthXl}
                            borderStyle="solid"
                            borderRadius={tokens.BorderRadiusL}
                            mr={4}
                            p={3}
                        >
                            <IconPlay />
                        </Box>
                    }
                    onClick={onOpen}
                    iconRight={false}
                    mt="auto"
                    size="m"
                    zIndex={1}
                >
                    <FormattedMessage defaultMessage="Play trailer" />
                </TextButton>
            </VideoTile>
            <MediaModal
                media={{
                    type: 'video',
                    src: videoUrl,
                }}
                index={0}
                total={1}
                closeLabel={formatMessage({
                    defaultMessage: 'Close',
                })}
                {...disclosureProps}
            />
        </>
    );
};

export default HeroVideo;
